<template>

    <div>

        <transition name="slide-right" mode="out-in">
            <router-view></router-view>
        </transition>

    </div>

</template>

<script>
import appSettingsMixin from "@/_mixins/app-settings-mixin"
import appMixin from "./mixins/app-mixin"

export default {
  name: "Application",
  created()
  {
    // debugger;
  },
  mixins : [appSettingsMixin,appMixin],
  computed: {},
  watch: {},
  data: () => ({}),
  methods: {},
};
</script>

<style lang="scss">
</style>
